export default "<div >\n\t<!-- <h5>Time Remaining : </h5> -->\n\t<h2>{{countDown | async | formatTime}}</h2>\n</div>\n\n";